/* ICR cart drawer (Kida Digital, Oct 2026): quantity, variant swap, remove, discount codes, upsells, free gift.
   Open/close and re-render after add to cart stay with the theme's cart-drawer.js. */
(function () {
  if (window.ICRCart) return;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var SECTIONS = ['cart-drawer', 'cart-icon-bubble', 'cart-icon-bubble--mobile'];
  var upCache = {};
  var giftTries = 0;
  var busy = false;

  function drawer() { return document.querySelector('cart-drawer'); }
  function state() { var d = drawer(); return d && d.querySelector('[data-icr-cd-state]'); }

  function showError(msg) {
    var d = drawer(), el = d && d.querySelector('[data-icr-cd-error]');
    if (!el) return;
    el.textContent = msg;
    el.hidden = !msg;
  }

  function notice(msg) {
    var d = drawer(), el = d && d.querySelector('[data-icr-cd-notice]');
    if (!el || !msg) return;
    el.textContent = msg;
    el.hidden = false;
  }

  function post(path, body) {
    body.sections = SECTIONS;
    body.sections_url = window.location.pathname;
    return fetch(root + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok || j.status) throw new Error(j.description || j.message || 'Sorry, something went wrong. Please try again.');
        return j;
      });
    });
  }

  function sectionHTML(html, sel) {
    var el = new DOMParser().parseFromString(html, 'text/html').querySelector(sel);
    return el ? el.innerHTML : null;
  }

  function apply(res) {
    var d = drawer();
    if (!d || !res.sections) return;
    var body = d.querySelector('[data-icr-cd-body]');
    var scroll = body ? body.scrollTop : 0;
    var a = document.activeElement, focusSel = null;
    if (a && d.contains(a) && a.dataset && a.dataset.key) {
      if (a.hasAttribute('data-icr-cd-input')) focusSel = '[data-icr-cd-input][data-key="' + a.dataset.key + '"]';
      else if (a.hasAttribute('data-icr-cd-variant')) focusSel = '[data-icr-cd-variant][data-key="' + a.dataset.key + '"]';
      else if (a.hasAttribute('data-icr-cd-qty')) focusSel = '[data-icr-cd-qty="' + a.dataset.icrCdQty.replace(/"/g, '') + '"][data-key="' + a.dataset.key + '"]';
    }
    var inner = res.sections['cart-drawer'] && sectionHTML(res.sections['cart-drawer'], '#CartDrawer');
    var wrap = d.querySelector('#CartDrawer');
    if (inner != null && wrap) wrap.innerHTML = inner;
    ['cart-icon-bubble', 'cart-icon-bubble--mobile'].forEach(function (id) {
      var el = document.getElementById(id);
      if (el && res.sections[id]) { var h = sectionHTML(res.sections[id], '.shopify-section'); if (h != null) el.innerHTML = h; }
    });
    var nb = d.querySelector('[data-icr-cd-body]');
    if (nb) nb.scrollTop = scroll;
    var f = focusSel && d.querySelector(focusSel);
    if (f) f.focus(); else if (focusSel) { var p = d.querySelector('.icr-cd__panel'); if (p) p.focus(); }
    if (window.publish && window.PUB_SUB_EVENTS) { try { publish(PUB_SUB_EVENTS.cartUpdate, { source: 'icr-cart' }); } catch (e) {} }
    document.dispatchEvent(new CustomEvent('icr:cart-updated'));
  }

  function run(promise, item) {
    busy = true;
    if (item) item.classList.add('is-loading');
    showError('');
    return promise.then(apply).catch(function (err) {
      if (item) item.classList.remove('is-loading');
      showError(err.message);
    }).finally(function () { busy = false; });
  }

  function change(key, qty) {
    var d = drawer(), item = d && d.querySelector('.icr-cd__item[data-key="' + key + '"]');
    return run(post('cart/change.js', { id: key, quantity: Math.max(0, qty) }), item);
  }

  // Free gift: add when the spend is reached, take it out again when it isn't
  function reconcileGift() {
    var st = state();
    if (!st || busy || giftTries > 10) return;
    var spend = +st.dataset.eligible || 0, need = +st.dataset.giftThreshold || 0;
    var vid = st.dataset.giftVariant, key = st.dataset.giftKey, qty = +st.dataset.giftQty || 0;
    if (!need) return;
    if (key && spend < need) {
      giftTries++;
      var msg = st.dataset.giftRemoved;
      change(key, 0).then(function () { notice(msg); });
    }
    else if (key && qty > 1) { giftTries++; change(key, 1); }
    else if (!key && vid && spend >= need) {
      giftTries++;
      run(post('cart/add.js', { items: [{ id: +vid, quantity: 1, properties: { _icr_gift: st.dataset.giftLabel || 'Free gift' } }] })).then(function () {
        var d = drawer(), g = d && d.querySelector('.icr-cd__item.is-gift');
        if (!g) return;
        g.classList.add('is-new');
        var b = d.querySelector('[data-icr-cd-body]');
        if (b) b.scrollTop = 0;
        setTimeout(function () { g.classList.remove('is-new'); }, 2400);
      });
    }
  }

  // Upsells: Search & Discovery complementary products for the newest cart item, related products as a fallback
  function upsells() {
    var d = drawer(), box = d && d.querySelector('[data-icr-cd-upsells]');
    if (!box) return;
    var pid = box.dataset.productId, limit = +box.dataset.limit || 3;
    var inCart = (box.dataset.inCart || '').split(',');
    function fill(html) {
      var list = box.querySelector('[data-icr-cd-ups-list]');
      var tmp = document.createElement('div');
      tmp.innerHTML = html;
      var n = 0;
      Array.prototype.slice.call(tmp.querySelectorAll('.icr-cd__up')).forEach(function (el) {
        if (n >= limit || inCart.indexOf(el.dataset.productId) > -1) return;
        list.appendChild(el);
        n++;
      });
      box.hidden = n === 0;
    }
    if (upCache[pid] != null) { fill(upCache[pid]); return; }
    function get(intent) {
      return fetch(root + 'recommendations/products?product_id=' + pid + '&limit=10&intent=' + intent + '&section_id=icr-cart-upsells')
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (t) { return sectionHTML(t, '.shopify-section') || ''; });
    }
    get('complementary').then(function (h) {
      return h.indexOf('icr-cd__up') > -1 ? h : get('related');
    }).then(function (h) {
      upCache[pid] = h;
      if (box.isConnected) fill(h);
    }).catch(function () {});
  }

  function after() { upsells(); setTimeout(reconcileGift, 30); }

  document.addEventListener('click', function (e) {
    var d = drawer();
    if (!d || !d.contains(e.target)) return;
    var close = e.target.closest('[data-icr-cd-close]');
    if (close) { if (d.close) d.close(); return; }
    var q = e.target.closest('[data-icr-cd-qty]');
    if (q && !busy) { change(q.dataset.key, parseInt(q.dataset.icrCdQty, 10) || 0); return; }
    var rc = e.target.closest('[data-icr-cd-remove-code]');
    if (rc && !busy) {
      var st = state(), keep = (st.dataset.codes || '').split(',').filter(function (c) { return c && c !== rc.dataset.icrCdRemoveCode; });
      run(post('cart/update.js', { discount: keep.join(',') }));
    }
  });

  document.addEventListener('change', function (e) {
    var d = drawer();
    if (!d || !d.contains(e.target)) return;
    var t = e.target;
    if (t.matches('[data-icr-cd-input]')) { var v = parseInt(t.value, 10); change(t.dataset.key, isNaN(v) ? 0 : v); return; }
    if (t.matches('[data-icr-cd-variant]')) {
      var up = {}; up[t.dataset.key] = 0; up[t.value] = +t.dataset.qty || 1;
      var item = t.closest('.icr-cd__item');
      run(post('cart/update.js', { updates: up }), item);
      return;
    }
    if (t.matches('[data-icr-cd-up-sel]')) {
      var o = t.options[t.selectedIndex], pr = t.closest('.icr-cd__up').querySelector('[data-icr-cd-up-price]');
      if (o && pr && o.dataset.price) pr.textContent = o.dataset.price;
    }
  });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('[data-icr-cd-discount]');
    if (!form) return;
    e.preventDefault();
    var code = (form.code.value || '').trim();
    if (!code || busy) return;
    var st = state(), err = drawer().querySelector('[data-icr-cd-disc-err]');
    var codes = (st.dataset.codes || '').split(',').filter(Boolean);
    if (codes.map(function (c) { return c.toLowerCase(); }).indexOf(code.toLowerCase()) > -1) { form.code.value = ''; return; }
    form.classList.add('is-loading');
    busy = true;
    post('cart/update.js', { discount: codes.concat(code).join(',') }).then(function (res) {
      var hit = (res.discount_codes || []).filter(function (c) { return c.code.toLowerCase() === code.toLowerCase(); })[0];
      if (hit && hit.applicable) return apply(res);
      // Not valid for this cart: put the codes back as they were and say so
      return post('cart/update.js', { discount: codes.join(',') }).then(function (r2) {
        apply(r2);
        var e2 = drawer().querySelector('[data-icr-cd-disc-err]');
        var det = drawer().querySelector('.icr-cd__disc');
        if (det) det.open = true;
        if (e2) { e2.textContent = st.dataset.discountError || 'Unfortunately this code is invalid'; e2.hidden = false; }
        var inp = drawer().querySelector('[data-icr-cd-discount] input');
        if (inp) { inp.value = code; inp.focus(); }
      });
    }).catch(function (x) {
      if (err) { err.textContent = x.message; err.hidden = false; }
    }).finally(function () { busy = false; form.classList.remove('is-loading'); });
  });

  function boot() {
    var d = drawer(), wrap = d && d.querySelector('#CartDrawer');
    if (!wrap) return;
    new MutationObserver(after).observe(wrap, { childList: true });
    after();
  }
  window.ICRCart = { change: change, refresh: after };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();